import BundleConfiguratorItem from "./component-library238.mjs";
import "./component-library239.mjs";
import normalizeComponent from "./component-library91.mjs";
const _sfc_main = {
  name: "BundleConfigurator",
  components: { BundleConfiguratorItem },
  props: {
    focusedItemIndex: { type: Number, default: void 0 },
    bundleItems: { type: Array, default: () => [] }
  },
  emits: ["select-variant"],
  data() {
    return { openItemIndex: this.focusedItemIndex };
  },
  methods: {
    handleOpenItemChange({ position }) {
      if (this.openItemIndex === position) {
        this.openItemIndex = void 0;
      } else {
        this.openItemIndex = position;
      }
    },
    isOpen({ position }) {
      return this.openItemIndex === position;
    }
  }
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("div", { staticClass: "bundle-configurator" }, [_c("div", { staticClass: "bundle-configurator__header" }, [_vm._v("Bestehend aus:")]), _vm._l(_vm.bundleItems, function(bundleItem) {
    return _c("BundleConfiguratorItem", { key: bundleItem.family.slug, attrs: { "bundle-item": bundleItem, "is-extended": _vm.isOpen(bundleItem) }, on: { "open-bundle-item-config": _vm.handleOpenItemChange, "select-variant": (args) => _vm.$emit("select-variant", args) } });
  })], 2);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "c3d2f49b",
  null,
  null
);
const BundleConfigurator = __component__.exports;
export {
  BundleConfigurator as default
};
